import { stringify } from 'query-string';
import { AbsolutePath } from './types';

declare const filterSearchBrand: unique symbol;

/**
 * A filtered list's search string, made only by noddi-ui-web's `filterSearch` from the list's own filters: a route
 * takes `filters?: FilterSearch` instead of spelling filter URL keys, which drift from what the list reads.
 */
export type FilterSearch = string & { readonly [filterSearchBrand]: true };

// Helper function to construct URLs with query parameters, similar to noddiAsync's getNoddiUrl
export function getUrlWithQueryParams({
  path,
  queryParams
}: {
  path: AbsolutePath;
  queryParams?: Record<string, unknown>;
}): AbsolutePath {
  const { filters, ...rest } = queryParams ?? {};
  // filter out empty params
  const filteredQueryParams = Object.entries(rest).reduce<Record<string, unknown>>((acc, [key, value]) => {
    if (value !== undefined && value !== null) {
      // Encode booleans as 1/0 so they round-trip with use-query-params' BooleanParam reader,
      // which only decodes "1"/"0" (not "true"/"false").
      acc[key] = typeof value === 'boolean' ? (value ? 1 : 0) : value;
    }
    return acc;
  }, {});

  const queryParamString = stringify(filteredQueryParams, {
    arrayFormat: 'none'
  });

  // `filters` is a `FilterSearch`, already encoded on the list's URL keys.
  const search = [queryParamString, typeof filters === 'string' ? filters : ''].filter(Boolean).join('&');
  const queryStringWithQuestionMark = search ? `?${search}` : '';

  return `${path}${queryStringWithQuestionMark}`;
}
